import React from 'react';
import background_2x from '../../../assets/header/background-2x.webp';
import logo from '../../../assets/header/logo.svg';
import { Box, Button, Divider, Typography, useMediaQuery } from '@mui/material';
import { endOfISOWeek, format, startOfISOWeek } from 'date-fns';

import Arrow from '../../../assets/common/register_arrow.svg';
import { useDataState } from '../../../providers/DataProvider.hooks';

export const Header = () => {
    const { totalClans, totalMembers, seasonNumber, seasonColor, seasonName } = useDataState();
    const isMobile = useMediaQuery('(max-width:1200px)');

    const localTimezoneOffset = new Date().getTimezoneOffset();
    const localTimezoneOffsetMs = localTimezoneOffset * 60 * 1000;
    const gmtTimeMs = new Date().getTime() + localTimezoneOffsetMs;
    const gmtDate = new Date(gmtTimeMs);

    const duration = `${format(startOfISOWeek(gmtDate), 'dd.MM')}-${format(endOfISOWeek(gmtDate), 'dd.MM')}`;

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    backgroundImage: `url(${background_2x})`,
                    backgroundSize: '2600px 980px',
                    backgroundPosition: isMobile ? 'calc(50% + 130px)' : 'center',
                    backgroundRepeat: 'no-repeat',
                }}
            >
                <Box
                    sx={{
                        maxWidth: '1920px',
                        width: '100%',
                        height: '980px',
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <Box
                        sx={{
                            maxWidth: '1256px',
                            width: '100%',
                            margin: '0 20px',
                        }}
                    >
                        <Box
                            sx={{
                                borderBottom: '1px solid #D8DFE5',
                                width: '392px',
                            }}
                        >
                            <img style={{ margin: '30px 0' }} src={logo} alt="logo" />
                        </Box>
                        <Typography
                            variant="h1"
                            sx={{
                                fontFamily: 'PlayfairDisplay',
                                color: seasonColor,
                                fontSize: '56px',
                                marginTop: '80px',
                            }}
                        >
                            {seasonName}
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: 'AvenirNext700',
                                color: '#0F0E0E',
                                fontSize: '56px',
                            }}
                        >
                            Tournament Season
                        </Typography>
                        <Box
                            sx={{
                                padding: '25px 0',
                                width: 'max-content',
                                display: 'flex',
                                '& p': {
                                    fontFamily: 'AvenirNext400',
                                    color: '#0F0E0E',
                                    opacity: 0.4,
                                    fontSize: '14px',
                                    lineHeight: 'normal',
                                    marginBottom: '5px',
                                },
                                '& span': {
                                    fontFamily: 'AvenirNext700',
                                    color: '#0F0E0E',
                                    fontSize: '24px',
                                },
                                '& hr': {
                                    mx: '40px',
                                    borderBottom: '1px solid #D8DFE5',
                                    height: '57px',
                                },
                            }}
                        >
                            <Box>
                                <Typography>Introducing</Typography>
                                <Typography component="span">{`Season ${seasonNumber}`}</Typography>
                            </Box>
                            <Divider orientation="vertical"></Divider>
                            <Box>
                                <Typography>Duration</Typography>
                                <Typography component="span">{duration}</Typography>
                            </Box>
                            <Divider orientation="vertical"></Divider>
                            <Box>
                                <Typography>Tournament Cat-petitors</Typography>
                                <Typography component="span">{`${totalClans ?? '-'} clans · ${
                                    totalMembers ?? '-'
                                } purr-sonalities`}</Typography>
                            </Box>
                        </Box>
                        <Typography
                            sx={{
                                fontFamily: 'AvenirNext400',
                                color: '#9298A1',
                                fontSize: '20px',
                                maxWidth: '700px',
                                lineHeight: 'normal',
                            }}
                        >
                            Become part of something bigger: join hands & paws, forge alliances, amplify your power, and
                            see who's truly the strongest clan out there!
                        </Typography>
                        <Button
                            sx={{
                                backgroundColor: seasonColor,
                                color: '#FFF',
                                fontFamily: 'AvenirNext700',
                                fontSize: '20px',
                                textTransform: 'none',
                                padding: '25px 40px',
                                borderRadius: '50px',
                                marginTop: '30px',
                                '& img': {
                                    marginLeft: '30px',
                                },
                                '&:hover': {
                                    backgroundColor: seasonColor,
                                    filter: 'brightness(85%)',
                                },
                                transition: 'all ease 0.3s',
                            }}
                            endIcon={<img src={Arrow} alt="app store logo" />}
                            onClick={() => {
                                window.open('https://forms.gle/GE2xmTqJhWys7AtJ7', '__blank');
                            }}
                        >
                            Register your own clan
                        </Button>
                    </Box>
                </Box>
            </Box>
        </>
    );
};
